export default "__VITE_PUBLIC_ASSET__6161ed2d__"